import { render, staticRenderFns } from "./DeviceTransferList.vue?vue&type=template&id=21c45fcd&scoped=true&"
import script from "./DeviceTransferList.vue?vue&type=script&lang=js&"
export * from "./DeviceTransferList.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTransferList.vue?vue&type=style&index=0&id=21c45fcd&lang=scss&scoped=true&"
import style1 from "./DeviceTransferList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c45fcd",
  null
  
)

export default component.exports